<template>
  <div>
    <v-data-table
      class="custom-data-table schedule-record-table"
      :headers="staffScheduleRecordHeaders"
      :items="list"
      :search="search"
      :loading="isLoadingTable"
      loading-text="Loading..."
      fixed-header
      height="470px"
      :class="{ 'highlight': hasNewScheduleRecord }"
    >
      <template v-slot:item.location="{ item }">
        <span class="text-body-3 neutral-041--text">{{ item.locationName }} ({{ item.locationCode }})</span>
      </template>
      <!-- Footer -->
      <template v-slot:footer.page-text="props">
        {{ props.pageStart }} - {{ props.pageStop }} of
        {{ props.itemsLength }}
      </template>

      <template v-slot:no-results>
        <v-img
          class="mx-auto table-icon mb-3"
          :src="require(`@/assets/images/general/icon_no-results.svg`)"
          width="39"
          contain
          height="51"
        />
        <p class="text-body-3 neutral-043--text mb-192">
          {{ $t('STAFF_MANAGEMENT.NO_MATCH_UPLOAD_HISTORY') }}
        </p>
      </template>
      <template v-slot:no-data>
        <v-img
          class="mx-auto table-icon mb-3"
          :src="require(`@/assets/images/general/icon_no-results.svg`)"
          width="39"
          contain
          height="51"
        />
        <p class="text-body-3 neutral-043--text mb-192">
          {{ $t('STAFF_MANAGEMENT.NO_EXIST_UPLOAD_HISTORY') }}
        </p>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'ScheduleRecordTable',
  components: {
  },
  props: {
    isLoadingTable: {
      type: Boolean,
      default: false
    },
    search: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    hasNewScheduleRecord: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      currentUserDict: (state) => state.currentUserDict
    }),
    staffScheduleRecordHeaders() {
      return [
        {
          text: this.$t('STAFF_MANAGEMENT.SHOP_LOCATIONS'),
          sortable: true,
          value: 'location',
          class: 'text-body-2 neutral-042--text'
        },
        {
          text: this.$t('STAFF_MANAGEMENT.MONTH'),
          sortable: false,
          value: 'scheduleMonth',
          width: '20%',
          class: 'text-body-2 neutral-042--text'
        },
        {
          text: this.$t('STAFF_MANAGEMENT.UPLOADER_TIME'),
          sortable: true,
          value: 'uploadTime',
          width: '30%',
          class: 'text-body-2 neutral-042--text'
        },
        {
          text: this.$t('STAFF_MANAGEMENT.UPLOADER'),
          sortable: true,
          value: 'uploader',
          width: '20%',
          class: 'text-body-2 neutral-042--text'
        }

      ];
    }
  },
  mounted() {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>

::v-deep.schedule-record-table {
  &.v-data-table .v-data-table__wrapper {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
}
.table-icon {
  margin-top: 140px;
}

@keyframes highlight{
  0%{
    background-color: $primary-004;
  }
  100%{
    background-color: $neutral-cold-058;
  }
}
</style>
